import { render, staticRenderFns } from "./AddBaseEmails.vue?vue&type=template&id=37602cc2"
import script from "./AddBaseEmails.vue?vue&type=script&lang=js"
export * from "./AddBaseEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports